import React from "react";
import RecognitionPage from "../shared/recognition/RecognitionPage";
import useRecognitionApi from "../shared/recognition/useRecognitionApi";

const REVENUE_CONFIG = {
  periodBy: "project",
  themeClass: "rr-theme--revenue",
  documentPrefix: "ПВ",
  entry: {
    debit: "Неактивированная дебиторская задолженность",
    credit: "Выручка",
  },
  texts: {
    noun: "Выручка",
    nounGenitive: "выручки",
    settingsTab: "Настройки проектов",
    totalLabel: "Итого выручки за период",
    detailsCaption: "Признание выручки",
    formTitle: "Создание признания выручки",
    calcTitle: "Расчет выручки",
    submit: "Признать выручку",
    confirmTitle: "Признать выручку?",
    toastTitle: "Выручка признана",
    note:
      "После подтверждения система сформирует управленческую операцию признания выручки и отразит её в Журнале операций.",
  },
};

function RevenueRecognition() {
  const remote = useRecognitionApi("revenue");
  if (!remote.data) {
    return <div className="rr">{remote.error || "Загрузка признания выручки..."}</div>;
  }
  return (
    <RecognitionPage
      config={REVENUE_CONFIG}
      data={remote.data}
      initialRecognitions={remote.recognitions}
      initialSettings={remote.settings}
      remote={remote}
    />
  );
}

export default RevenueRecognition;
